import React from 'react';
import { IonText } from '@ionic/react';
import SalesActivityCard from './SalesActivityCard';

interface IProps {
    salesActivity: any[];
}

const SalesActivities: React.FC<IProps> = (props) => {
    return (
        <>
            {Array.isArray(props.salesActivity) && props.salesActivity.map((activity, index) => <SalesActivityCard salesActivity={activity} key={index} />)}
            {(!Array.isArray(props.salesActivity) || props.salesActivity.length === 0) && (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '48px 24px', gap: '8px' }}>
                    <IonText color="medium" style={{ fontSize: '14px' }}>No activities found</IonText>
                    <IonText color="medium" style={{ fontSize: '13px' }}>Pull to refresh</IonText>
                </div>
            )}
        </>
    );
};

export default SalesActivities;
